<form name="loginform" class="form-material login-form" id="loginform" (ngSubmit)="login()" novalidate>
  <h1>Login</h1>
  <div>
    <div id="orange_separator"></div>
  </div>

  <!-- Account type (cosmetic; carried over from the prior design) -->
  <bk-segmented-control class="login-tabs"
                        [options]="accountTypes"
                        [value]="accountType"
                        (valueChange)="accountType = $event"></bk-segmented-control>

  <app-copyable-message *ngIf="error" variant="danger" extraClass="mt-3 mb-1" [message]="error"></app-copyable-message>

  <div class="field">
    <label for="login-username">Username</label>
    <input type="text" id="login-username" autocomplete="username"
           [(ngModel)]="model.username" class="form-control" bkInput name="username" />
  </div>

  <div class="field">
    <label for="login-password">Password</label>
    <div class="login-pw">
      <input [type]="showPassword ? 'text' : 'password'" id="login-password" autocomplete="current-password"
             [(ngModel)]="model.password" class="form-control" bkInput name="password" />
      <button type="button" class="login-pw__toggle"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
              [attr.aria-pressed]="showPassword"
              (click)="showPassword = !showPassword">
        <svg *ngIf="!showPassword" viewBox="0 0 24 24" width="20" height="20" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <svg *ngIf="showPassword" viewBox="0 0 24 24" width="20" height="20" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9.9 4.24A9.12 9.12 0 0 1 12 5c6.5 0 10 7 10 7a13.2 13.2 0 0 1-1.67 2.68" />
          <path d="M6.61 6.61A13.5 13.5 0 0 0 2 12s3.5 7 10 7a9.7 9.7 0 0 0 5.39-1.61" />
          <line x1="2" y1="2" x2="22" y2="22" />
        </svg>
      </button>
    </div>
  </div>

  <button bkButton color="primary" size="lg" block [loading]="loading" [disabled]="loading" class="login-submit">
    Log In
  </button>

  <div class="text-end login-forgot">
    <a routerLink="/forgot-password" id="forgot_password">Forgot username or password?</a>
  </div>

  <div class="login-divider"><span>or continue with</span></div>

  <div class="login-social">
    <button type="button" class="social-btn" aria-label="Sign in with Apple" (click)="signinWithApple()">
      <img src="/assets/img/apple-icon.png" alt="" />
    </button>
    <button type="button" class="social-btn" aria-label="Sign in with Facebook" (click)="signinWithFacebook()">
      <img src="/assets/img/fb-icon.png" alt="" />
    </button>
    <asl-google-signin-button class="btn-google-signin" shape="circle" size="large" width="40" height="40">
      <img src="/assets/img/google-icon.png" alt="Sign in with Google" />
    </asl-google-signin-button>
  </div>

  <button bkButton kind="outlined" color="primary" size="md" block type="button"
          class="login-sso" (click)="signinWithAuth0()">
    Single Sign On
  </button>

  <p class="login-create">
    <a href="javascript:void(0)" id="create_account">Create a FREE Account</a>
  </p>
</form>
